import script from "./RightBar.vue?vue&type=script&setup=true&lang=js"
export * from "./RightBar.vue?vue&type=script&setup=true&lang=js"

import "./RightBar.vue?vue&type=style&index=0&id=45dd8904&lang=scss"

const __exports__ = script;

export default __exports__